import { ApiService } from './api';

export type Agent = {
  id: string;
  workspaceId: number;
  websiteUrl: string | null;
  businessSummary: string | null;
  offerings: { name: string; description: string }[] | null;
  icp: {
    title: string;
    seniority: string;
    industry: string;
    companySize: string;
    geography: string;
    customFilters: string[];
  } | null;
  outreachGoal: string | null;
  messagingTone: string | null;
  status: 'active' | 'paused' | 'draft';
  leadsFound: number;
  messagesGenerated: number;
  scrapeJobId: string | null;
  createdAt: string;
  updatedAt: string;
};

const api = new ApiService();

export const agentService = {
  getAll: () => api.get<Agent[]>('/api/agents'),

  getOne: (id: string) => api.get<Agent>(`/api/agents/${id}`),

  update: (id: string, data: Partial<Agent>) => api.patch<Agent>(`/api/agents/${id}`, data),

  getLeads: (id: string) => api.get<any[]>(`/api/agents/${id}/leads`),

  gatherProspects: (id: string) => api.post<{ leads: any[]; activity: string[]; count: number }>(`/api/agents/${id}/gather-prospects`),

  bulkDeleteLeads: (agentId: string, ids: number[]) =>
    fetch(`/api/agents/${agentId}/leads`, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ ids }),
    }).then(r => r.json()),

  delete: (id: string) => api.delete(`/api/agents/${id}`),

  toggleStatus: (id: string, data: { status: 'active' | 'paused' }) =>
    api.patch<Agent>(`/api/agents/${id}/status`, data),
};
